module.exports = __webpack_public_path__ + "img/modal.73ca1c25.png";